import { useState, useCallback } from 'react';
import { NoteView } from '../../../../../../services/CaseManagementService/types/caseManageTypes';

/**
 * Hook for managing note view dialog state
 */
export function useNoteViewDialog() {
  const [selectedNote, setSelectedNote] = useState<NoteView | null>(null);
  const [showViewDialog, setShowViewDialog] = useState(false);

  const handleRowSelected = useCallback((args: { data: NoteView }) => {
    const selectedItem = args.data;
    setSelectedNote(selectedItem);
    setShowViewDialog(true);
  }, []);

  const handleCloseViewDialog = useCallback(() => {
    setShowViewDialog(false);
    setSelectedNote(null);
  }, []);

  return {
    selectedNote,
    showViewDialog,
    handleRowSelected,
    handleCloseViewDialog,
  };
}
